
import _ from 'lodash';
import { mintegralChannelList, bigMediaChannelList, nonInteractiveCreationTypeList, interactiveCreationTypeList } from '@/views/demand/utils/creation';
import { interactiveChannelList } from '@com/utils/channel';
import Creation from './creation.vue';
import DeleteButton from '../components/delete-button.vue';
import { generateCreation } from '@/views/demand/utils/creation';
import { typeList } from '@/common/demand';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';

export default {
  components: {
    Creation: Creation,
    DeleteButton: DeleteButton
  },

  props: {
    demand: {
      type: Object,
      required: true
    },

    list: {
      type: Array,
      required: true
    },

    validate: {
      type: Function,
      default: function _default() {}
    },

    updateCreationList: {
      type: Function,
      default: function _default() {}
    },

    emptyCreationList: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    demandType: function demandType() {
      return this.demand.type ? useValueExchangeLabel(this.demand.type, typeList) : '';
    },


    // 根据投放渠道与素材类型筛选创意信息中的渠道信息
    channelList: function channelList() {
      var channelType = Number(this.demand.channel_type);
      var type = Number(this.demand.type);
      var materialSource = Number(this.demand.material_source);

      // “需求类型=交互素材”，“投放渠道”包括所有渠道
      if (type === 1) {
        // ss上传素材限制可选择来源渠道， 支持广告主素材适配 DSP 之后，后续只有 mintegral 渠道
        if (materialSource === 3) {
          return _.cloneDeep(interactiveChannelList).filter(function (item) {
            return item.value === 21;
          });
        }
        return _.cloneDeep(interactiveChannelList).filter(function (item) {
          return item.value !== 1 && item.value !== 2;
        });
      }

      // “需求类型=非交互素材”
      if (type === 2) {
        // 投放渠道类型=mintegral，创意要求中的“投放渠道”限制只能选择“MTG/DSP”
        if (channelType === 1) {
          return _.cloneDeep(mintegralChannelList());
        }
        // 投放渠道类型=大媒体，“投放渠道”可选内容包括“Google Adwords、Applovin、unity、Facebook，广点通、今日头条、ironsource、百度信息流、vungle、快手、其他”
        return _.cloneDeep(bigMediaChannelList());
      }
      return [];
    },
    creationTypeList: function creationTypeList() {
      var type = Number(this.demand.type);

      // 需求类型=交互素材：创意类型可选项包括“playable/动态endcard”，单选
      if (type === 1) {
        return _.cloneDeep(interactiveCreationTypeList);
      }

      // “需求类型=非交互素材”：“需求类型”可选项包括“视频设计、视频修改、图片设计、图片修改、GIF”，单选
      if (type === 2) {
        return _.cloneDeep(nonInteractiveCreationTypeList);
      }

      return [];
    },
    formItemList: function formItemList() {
      // const type = Number(this.demand.type)
      var list = {
        channel: {
          visible: true,
          prop: 'channel',
          style: Number(this.demand.type) === 2 ? '' : 'width: 100%;',
          rules: [{
            required: true,
            message: '请选择投放渠道',
            trigger: 'change'
          }],
          params: {
            style: Number(this.demand.type) === 2 ? '' : 'width: 100%;',
            clearable: true,
            placeholder: '请选择投放渠道',
            filterable: true,
            multiple: Number(this.demand.type) === 1,
            options: this.channelList
          }
        },
        type: {
          visible: Number(this.demand.type) === 2,
          prop: 'type',
          rules: [{
            required: true,
            message: '请选择创意类型',
            trigger: 'change'
          }],
          params: {
            clearable: true,
            placeholder: '请选择创意类型',
            options: this.creationTypeList
          }
        },
        languages: {
          visible: true,
          prop: 'languages',
          style: 'width: 100%;',
          rules: [{
            required: true,
            message: '请选择语言',
            trigger: 'change'
          }],
          params: {
            disabled: Number(this.demand.material_source) === 3,
            clearable: true,
            placeholder: '请选择语言',
            filterable: true,
            multiple: true,
            style: 'width: 100%;'
          }
        },
        sizes: {
          // 需求类型=非交互素材：增加投放尺寸选项
          visible: Number(this.demand.type) === 2,
          prop: 'sizes',
          style: 'width: 100%;',
          rules: [{
            required: true,
            message: '请选择投放尺寸',
            trigger: 'change'
          }],
          params: {
            style: 'width: 100%;',
            options: []
          }
        }
      };
      return list;
    }
  },

  watch: {
    // 当投放渠道类型与需求类型变化时，清空创意需求表单
    'demand.channel_type': function demandChannel_type(newVal, oldVal) {
      if (newVal && oldVal) {
        this.resetCreationForms();
      }
    },


    // 当投放渠道类型与需求类型变化时，清空创意需求表单
    'demand.type': function demandType(newVal, oldVal) {
      if (newVal && oldVal) {
        this.resetCreationForms();
      }
    },


    // 当投放渠道类型,需求类型与素材来源变化时，清空创意需求表单
    'demand.material_source': function demandMaterial_source(newVal, oldVal) {
      if (newVal && oldVal) {
        this.resetCreationForms();
      }
    }
  },

  mounted: function mounted() {},


  methods: {
    // 点击创意组旁的【delete】，可删除对应创意组，仅可删除动态新增的创意组
    deleteCreation: function deleteCreation(index) {
      if (index === 0) return; // 第一条不给删
      var newList = _.cloneDeep(this.list);
      newList.splice(index, 1);
      this.updateCreationList(newList);
    },


    // "创意要求"部分默认显示一组内容，不可删除，点击"添加创意需求“，在下方动态新增一组创意要求组，根据投放渠道、需求类型显示对应内容
    addCreation: function addCreation() {
      var newList = _.cloneDeep(this.list);
      newList.push(generateCreation());
      this.updateCreationList(newList);
    },
    resetCreationForms: function resetCreationForms() {
      var _this = this;

      this.$refs.creation.forEach(function (item) {
        item.$refs.form.resetFields();
        item.$refs.form.clearValidate();
      });
      this.$nextTick(function () {
        _this.emptyCreationList();
      });
    }
  }
};